import { render, staticRenderFns } from "./ScannedItems.vue?vue&type=template&id=49d198a6"
import script from "./ScannedItems.vue?vue&type=script&lang=js"
export * from "./ScannedItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports